import { Modal, Button, Row, Col, Alert, Table, Form, Spinner, Tabs, Tab, Card } from "react-bootstrap";
import { CheckCircle, XCircle } from "react-bootstrap-icons";
import { formatCurrency } from "../../../store/config";

function MembershipRequestDetailsModal({
    show,
    onHide,
    request,
    processingAction,
    transactionReference,
    setTransactionReference,
    handleUpdateStatus,
    StatusBadge
}) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title>Membership Withdrawal Request Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {request && (
                    <>
                        <div className="mb-4">
                            <h6 className="border-bottom pb-2">Request Information</h6>
                            <Row>
                                <Col md={6}>
                                    <small className="text-muted d-block">Request Date</small>
                                    <div>{new Date(request.createdAt || request.requestDate).toLocaleDateString()}</div>
                                </Col>
                                <Col md={6}>
                                    <small className="text-muted d-block">Status</small>
                                    <StatusBadge status={request.status} />
                                </Col>
                                {request.comments && (
                                    <Col xs={12} className="mt-3">
                                        <Alert variant={request.status === "rejected" ? "danger" : "info"}>
                                            <strong>Comments:</strong> {request.comments}
                                        </Alert>
                                    </Col>
                                )}
                                {request.transactionReference && (
                                    <Col xs={12} className="mt-3">
                                        <Alert variant="success">
                                            <strong>Transaction Reference:</strong> {request.transactionReference}
                                            {request.processedDate && (
                                                <>
                                                    <br />
                                                    <strong>Processed Date:</strong> {new Date(request.processedDate).toLocaleDateString()}
                                                </>
                                            )}
                                        </Alert>
                                    </Col>
                                )}
                            </Row>
                        </div>

                        <div className="mb-4">
                            <h6 className="border-bottom pb-2">Member Information</h6>
                            <Row>
                                <Col md={6} className="mb-2">
                                    <small className="text-muted d-block">Member ID</small>
                                    <div>{request.memberId || request.userId}</div>
                                </Col>
                                <Col md={6} className="mb-2">
                                    <small className="text-muted d-block">Full Name</small>
                                    <div>{request.personalInfo?.fullName || "N/A"}</div>
                                </Col>
                                <Col md={6} className="mb-2">
                                    <small className="text-muted d-block">Email</small>
                                    <div>{request.personalInfo?.email || "N/A"}</div>
                                </Col>
                                <Col md={6} className="mb-2">
                                    <small className="text-muted d-block">Phone Number</small>
                                    <div>{request.personalInfo?.phoneNumber || "N/A"}</div>
                                </Col>
                                {request.personalInfo?.faculty && (
                                    <Col md={6} className="mb-2">
                                        <small className="text-muted d-block">Faculty</small>
                                        <div>{request.personalInfo.faculty}</div>
                                    </Col>
                                )}
                                {request.personalInfo?.department && (
                                    <Col md={6} className="mb-2">
                                        <small className="text-muted d-block">Department</small>
                                        <div>{request.personalInfo.department}</div>
                                    </Col>
                                )}
                                {request.personalInfo?.salaryStructure && (
                                    <Col md={12} className="mb-2">
                                        <small className="text-muted d-block">Salary Structure</small>
                                        <div>{request.personalInfo.salaryStructure}</div>
                                    </Col>
                                )}
                            </Row>
                        </div>

                        <div className="mb-4">
                            <h6 className="border-bottom pb-2">Bank Details</h6>
                            <Row>
                                <Col md={4} className="mb-2">
                                    <small className="text-muted d-block">Account Name</small>
                                    <div>{request.bankDetails?.accountName || "N/A"}</div>
                                </Col>
                                <Col md={4} className="mb-2">
                                    <small className="text-muted d-block">Account Number</small>
                                    <div>{request.bankDetails?.accountNumber || "N/A"}</div>
                                </Col>
                                <Col md={4} className="mb-2">
                                    <small className="text-muted d-block">Bank Name</small>
                                    <div>{request.bankDetails?.bankName || "N/A"}</div>
                                </Col>
                            </Row>
                        </div>

                        <div className="mb-4">
                            <h6 className="border-bottom pb-2">Membership Withdrawal Details</h6>
                            <Row className="mt-2">
                                <Col md={6} className="mb-2">
                                    <small className="text-muted d-block">Effective Date</small>
                                    <div>
                                        {request.withdrawalDetails?.effectiveDate ?
                                            new Date(request.withdrawalDetails.effectiveDate).toLocaleDateString() :
                                            "N/A"}
                                    </div>
                                </Col>
                            </Row>

                            <Tabs defaultActiveKey="summary" className="mt-3">
                                <Tab eventKey="summary" title="Summary">
                                    <Card className="bg-light mt-3">
                                        <Card.Body>
                                            <Table borderless className="mb-0">
                                                <tbody>
                                                    <tr>
                                                        <th>Total Savings Balance</th>
                                                        <td className="text-right">
                                                            {formatCurrency(request.withdrawalDetails?.totalSavings || 0)}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Outstanding Loans</th>
                                                        <td className="text-right">
                                                            ({formatCurrency(request.withdrawalDetails?.totalLoans || 0)})
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Net Balance</th>
                                                        <td className="text-right">
                                                            {formatCurrency(request.withdrawalDetails?.netBalance || 0)}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            Service Charge ({(request.withdrawalDetails?.serviceChargeRate || 0) * 100}%)
                                                        </th>
                                                        <td className="text-right">
                                                            ({formatCurrency(request.withdrawalDetails?.serviceChargeAmount || 0)})
                                                        </td>
                                                    </tr>
                                                    <tr className="table-primary">
                                                        <th className="h5">Amount Due From Society</th>
                                                        <td className="text-right h5">
                                                            {formatCurrency(request.withdrawalDetails?.amountDue || 0)}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Card.Body>
                                    </Card>
                                </Tab>
                                <Tab eventKey="savings" title="Savings Details">
                                    {request.withdrawalDetails?.savingsItems?.length > 0 ? (
                                        <Table bordered hover responsive className="mt-3">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th>Savings Type</th>
                                                    <th className="text-right">Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {request.withdrawalDetails.savingsItems.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.name}</td>
                                                        <td className="text-right">{formatCurrency(item.value)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot className="table-light">
                                                <tr>
                                                    <th>Total Savings</th>
                                                    <th className="text-right">
                                                        {formatCurrency(request.withdrawalDetails.totalSavings)}
                                                    </th>
                                                </tr>
                                            </tfoot>
                                        </Table>
                                    ) : (
                                        <Alert variant="info" className="mt-3">No savings details available</Alert>
                                    )}
                                </Tab>
                                <Tab eventKey="loans" title="Loans Details">
                                    {request.withdrawalDetails?.loanItems?.length > 0 ? (
                                        <Table bordered hover responsive className="mt-3">
                                            <thead className="table-danger">
                                                <tr>
                                                    <th>Loan Type</th>
                                                    <th className="text-right">Outstanding Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {request.withdrawalDetails.loanItems.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.name}</td>
                                                        <td className="text-right">{formatCurrency(item.value)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot className="table-light">
                                                <tr>
                                                    <th>Total Loans</th>
                                                    <th className="text-right">
                                                        {formatCurrency(request.withdrawalDetails.totalLoans)}
                                                    </th>
                                                </tr>
                                            </tfoot>
                                        </Table>
                                    ) : (
                                        <Alert variant="info" className="mt-3">No outstanding loans</Alert>
                                    )}
                                </Tab>
                            </Tabs>
                        </div>

                        {/* Actions for pending requests */}
                        {request.status === "pending" && (
                            <div className="d-flex justify-content-end mt-4">
                                <Button
                                    variant="danger"
                                    onClick={() => handleUpdateStatus("rejected")}
                                    disabled={processingAction}
                                    className="mr-2"
                                >
                                    <XCircle className="mr-1" /> Reject Request
                                </Button>
                                <Button
                                    variant="success"
                                    onClick={() => handleUpdateStatus("approved")}
                                    disabled={processingAction}
                                >
                                    <CheckCircle className="mr-1" /> Approve Request
                                </Button>
                            </div>
                        )}

                        {/* Actions for approved requests */}
                        {request.status === "approved" && (
                            <div className="mt-4">
                                <Form.Group className="mb-3">
                                    <Form.Label>Transaction Reference</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter transaction reference or payment ID"
                                        value={transactionReference}
                                        onChange={(e) => setTransactionReference(e.target.value)}
                                    />
                                    <Form.Text className="text-muted">
                                        Enter the bank transaction reference or payment ID after processing the payment
                                    </Form.Text>
                                </Form.Group>
                                <div className="d-flex justify-content-end">
                                    <Button
                                        variant="primary"
                                        onClick={() => handleUpdateStatus("processed")}
                                        disabled={processingAction || !transactionReference.trim()}
                                    >
                                        {processingAction ? (
                                            <>
                                                <Spinner animation="border" size="sm" className="mr-2" />
                                                Processing...
                                            </>
                                        ) : (
                                            <>Mark as Processed</>
                                        )}
                                    </Button>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default MembershipRequestDetailsModal;
